import { render, staticRenderFns } from "./ProductReviewsList.vue?vue&type=template&id=60fdc361&scoped=true&"
import script from "./ProductReviewsList.vue?vue&type=script&lang=js&"
export * from "./ProductReviewsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fdc361",
  null
  
)

export default component.exports